import { noAuto } from "@fortawesome/fontawesome-svg-core";
import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  Image,
  View,
  Svg,
  Path
} from "@react-pdf/renderer";
import * as React from "react";
import moment from "moment";

import { IPdflink, ICommission_bulletin, ICommission_bulletin_line, IFormula } from "../../types/interfaces";
import { getCommissionType, getNationality } from "../../services/misc";
import { constants } from "../../types/constants";
import { getEncModeRegl } from '../../services/misc';

Font.register({
  family: 'Open Sans',
  fonts: [
  { src: '/fonts/open-sans-regular.ttf' },
  { src: '/fonts/open-sans-italic.ttf', fontStyle: "italic" },
  { src: '/fonts/open-sans-600italic.ttf', fontWeight: 600, fontStyle: "italic" },
  { src: '/fonts/open-sans-600.ttf', fontWeight: 600 },
  { src: '/fonts/open-sans-300.ttf', fontWeight: 300 }
  ]
});

Font.register({
  family: 'Cairo',
  fonts: [
    { src: '/fonts/Cairo-Regular.ttf' }, // Regular font
    { src: '/fonts/Cairo-Bold.ttf', fontWeight: 700 }, // Bold font
    { src: '/fonts/Cairo-Light.ttf', fontWeight: 300 } // Light font
  ]
});

const MyDocument: any = Document
const MyPage: any = Page
const MySvg: any = Svg

const CommissionDocument: React.FC<IPdflink> = ({ documentType, data, showPreviewWatermark, title, fileObject }: IPdflink) => {
  if(!data)
    return (<MyDocument>
      <MyPage size="A4">
        <View>
          <Text>Erreur 968</Text>
        </View>
      </MyPage>
    </MyDocument>)
  
  const PAGE_SIDE_PADDING = 40,
    BORDER_COLOR = '#bfbfbf',
    BORDER_STYLE = 'solid',
    BORDER_WIDTH = 1,
    HEADER_BG_COLOR = "green",
    HEADER_COLOR = "#ffffff",
    DEFAULT_FONT_SIZE = 7;

    console.log({kkk: data.encaissements1})
  
  const styles = StyleSheet.create({
    body: {
      padding: PAGE_SIDE_PADDING,
      paddingBottom: PAGE_SIDE_PADDING
    },
    logoContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      marginBottom: 15
    },
    middleLogoContainer1: {
      flex: 5
    },
    middleLogoContainer2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "80%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      color: "green",
      fontFamily: 'Open Sans'
    },
    clientTitleContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      marginBottom: 20
    },
    clientTitleView1: {
      width: "100%"
    },
    clientTitleView2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: 20,
      marginBottom: 25,
      width: "80%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      color: "green",
      fontFamily: 'Open Sans',
      textAlign: "center",
      fontSize: 18,
      backgroundColor: "#fefefe",
      paddingVertical: 12
    },
    middleLogoText: {
      width: "100%",
      // flex: 1,
      textAlign: "center",
      fontSize: 22,
      fontWeight: 600,
      textTransform: "uppercase"
    },
    middleLogoTextTop: {
      alignItems: "flex-end"
    },
    middleLogoTextBottom: {
      alignItems: "flex-start"
    },
    table: { 
      // display: "table", 
      width: "auto", 
      fontFamily: 'Open Sans',
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderRightWidth: 0, 
      borderBottomWidth: 0,
      marginBottom: 15
    },
    tableRow: { 
      margin: "auto", 
      flexDirection: "row" 
    },
    // footerRow: { 
    //   marginLeft: COL1_WIDTH + '%', 
    //   flexDirection: "row" 
    // },
    headerCol: { 
      backgroundColor: "#62af42",
      color: "white",
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderBottomColor: 'green',
      borderWidth: 1,
      fontWeight: 600,
      textAlign: "center"
    },
    rowCol: { 
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      textAlign: "center",
      fontFamily: 'Open Sans',
      fontWeight: 300,
      // borderLeftWidth: 0,
      // borderTopWidth: 0 
    },
    footerCol: {
      backgroundColor: "#62af42",
      color: "white",
      fontWeight: 600
    },
    cellText: { 
      marginVertical: 5,
      // marginHorizontal: 2,
      textAlign: "center",
      fontSize: 8
    },
    headerText: {
      fontWeight: 600
    },
    logo: {
      height: "auto",
      flex: 1
    },
    dateFournisseurView: {
      color: "#555555",
      fontSize: 12,
      // width: "100%",
      fontFamily: 'Open Sans',
      justifyContent: "flex-end",
      flexDirection: "row",
      marginBottom: 10
    },
    bvView: {
      color: "#000000",
      fontSize: 11,
      fontFamily: 'Open Sans',
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "column",
      marginLeft: 2,
      marginBottom: 10
    },
    titlesView: {
      color: "#000000",
      fontSize: 12,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginTop: 7,
      marginBottom: 7
    },
    cardContainer1: {
      color: "#000000",
      fontSize: 10,
      fontFamily: 'Open Sans',
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginBottom: 10
    },
    cardContainer2: {
      // display: "table",
      width: "100%"
    },
    clientCardContainer: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      fontFamily: 'Open Sans',
      color: "#000000",
      fontSize: 11,
    },
    cardRow: {
      width: "100%",
      flexDirection: "row",
      // marginBottom: 4,
      marginVertical: 0,
      paddingVertical: 0,
    },
    cardCellTitle: {
      fontStyle: "italic",
      width: "20%"
    },
    cardCellValue: {
      fontWeight: 600,
      width: "20%"
    },
    cardCellSpace: {
      width: "20%"
    },
    clientCardCellTitle: {
      fontWeight: 600,
      borderRightWidth: 2,
      borderRightColor: "green",
      borderRightStyle: "solid",
      paddingHorizontal: 6,
      paddingVertical: 8,
      borderBottomWidth: 1,
      borderBottomColor: "rgb(172, 210, 172)",
      borderBottomStyle: "solid",
      backgroundColor: "#f2f2f2",
      flex: 1
    },
    clientCardCellValue: {
      fontStyle: "italic",
      paddingHorizontal: 6,
      paddingVertical: 8,
      borderBottomWidth: 1,
      borderBottomColor: "rgb(172, 210, 172)",
      borderBottomStyle: "solid",
      backgroundColor: "#fefefe",
      flex: 1
    },
    arreteView: {
      color: "#333333",
      fontSize: 10,
      fontStyle: "italic",
      fontFamily: 'Open Sans',
      width: "100%",
      marginTop: 20
    },
    directionText: {
      color: "#000000",
      fontSize: 12,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      marginLeft: "70%",
      marginTop: 25
    },
    textMargin: {
      marginBottom: 4
    },
    watermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      transform: "rotate(-60deg)",
      fontSize: 50,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .1
    },
    previewWatermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      fontSize: 80,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .4
    },
    borderTest: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "green"
    },
    borderTest2: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "red"
    },
    pageCountContainer: {
      position: "absolute",
      bottom: 14,
      left: PAGE_SIDE_PADDING,
      paddingTop: 8,
      paddingBottom: 8,
      width: "100%",
      color: "#333333",
      fontSize: 8
    },
    pageCountText: {
      textAlign: "center",
      marginBottom: 4
    },
    lastElement: {
      marginBottom: 0,
      paddingBottom: 0
    },
    formulaIdDiv: {
      color: "white",
    },
    dtSection: {
      borderWidth: 2,
      borderRadius: 5,
      padding: "6px 15px 2px",
      marginVertical: 2
    },
    signCol: {
      fontFamily: 'Open Sans',
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderWidth: BORDER_WIDTH,
    },
    headerBgColor: {
      backgroundColor: HEADER_BG_COLOR,
      color: HEADER_COLOR,
    },
    infoView: {
      color: "#000000",
      fontSize: 10,
      fontFamily: 'Open Sans',
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginBottom: 10
    },
    shemsWatermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      transform: "rotate(-90deg)",
      opacity: .2,
      overflow: "hidden"
    }
  });

  console.log(data.clients1.filter(e => !!e.desiste || !!e.desiste_p))

  const ClientRow = ({data: e, sub = false}) => {
    return <View style={{fontSize: 10, marginVertical: 5}}>
      <Text style={{fontWeight: 300, fontFamily: 'Open Sans', ...(sub ? {paddingLeft: 10} : {})}}>
        {sub ? "• " : ""}{e.client?.CIVILITE ? e.client.CIVILITE === "Ste" ? "La société" : e.client?.CIVILITE : ""} <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{e.client?.NOM || "???"}{e.client?.PRENOM ? ` ${e.client?.PRENOM}` : ""}</Text> {e.client?.CIVILITE !== "Ste" ? "demeurant à" : "adresse:"} <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{e.client?.ADRESSE || "???"}</Text>. De nationalité <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{getNationality(e.client?.NATIONALITE)}</Text>. {e.client?.CIVILITE !== "Ste" ? "Né(e)" : "Créé"} le <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{e.client?.DATE_NAISS ? moment(e.client?.DATE_NAISS).format('DD/MM/YYYY') : "???"}</Text> à <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{e.client?.LIEU_NAISS || ""}</Text> {e.client?.CIVILITE !== "Ste" ? (e.client?.CIN ? "titulaire de la carte d'identité nationale" : "titulaire du passeport") : "RC"} N° <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{e.client?.CIN || e.client?.PASSPORT || "???"}</Text>
      </Text>
      {!!(e.client.CIVILITE === "Ste" && e.client?.societeRepBys?.length) && <>
        <Text style={{fontWeight: 300, fontFamily: 'Open Sans', marginTop: 3}}>Représentée par:</Text>
        {e.client.societeRepBys.map((e, key) => <ClientRow data={{client: e.clientRepBys}} sub />)}
      </>}
    </View>
  }

  // const ClientPRow = ({data: e}) => {
  //   return <Row className="linesConfirmationLines">
  //     <Col xs="12" className="fullFlexCenter"><FontAwesomeIcon icon={faUserPlus} /><div style={{flex: 1}}>Nom: <b>{e.NOM || "-"} {e.PRENOM || ""}</b>&nbsp;&nbsp;CIN: <b>{e.CIN || "-"}</b></div></Col>
  //   </Row>
  // }

  // const EncaissementRow = ({data: e}) => {
  //   return <Row className="linesConfirmationLines">
  //     <Col xs="12" className="fullFlexCenter"><FontAwesomeIcon icon={faMoneyCheckAlt} /><div style={{flex: 1}}>{getEncModeRegl(e.encaissement?.MODE_REGL)} N°: <b>{e.encaissement?.REF_REGLEMENT || "-"}</b>&nbsp;&nbsp;Montant: <b>{(e.PART || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</b></div></Col>
  //   </Row>
  // }
  
  return (
  <MyDocument creator={"ayoub laazazi"} producer={"producer"} title={title} author={"ayoub laazazi"}>
    <MyPage size="A4" style={{...styles.body, position: "relative"}}>
      {showPreviewWatermark ? <View style={styles.previewWatermark} fixed>
        <Text>Aperçu</Text>
      </View> : null}
      
      <View style={styles.shemsWatermark} fixed>
        {[...Array(38)].map((_, rowIndex) => (
          <View key={rowIndex} style={{ flexDirection: 'row', justifyContent: 'center' }}>
            {[...Array(20)].map((_, colIndex) => (
              <Text key={colIndex} style={{
                  fontSize: 6,
                  fontFamily: 'Cairo',
                  color: "#aaaaaa",
                  marginHorizontal: 1,
                  marginVertical: 2,
                }}>شمس المدينة •</Text>
            ))}
          </View>
        ))}
      </View>
      <View style={styles.logoContainer} fixed>
        <View style={styles.clientTitleView1}>
          <View style={styles.clientTitleView2}>
            <Text>
              {!!data.changeBien1 ? "Annulation et transfert" : data.clients1.filter(e => !!e.transfere).length || data.clients2.filter(e => !!e.transfere).length || data.encaissements1.filter(e => !!e.transfere).length || data.encaissements2.filter(e => !!e.transfere).length ? "Transfert" : "Désistement"}
            </Text>
          </View>
        </View>
      </View>

      {!!(data.clients1.filter(e => !!e.desiste || !!e.desiste_p).length || data.encaissements1.filter(e => !!e.desiste).length) && <View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>Le{data.clients1.filter(e => !!e.desiste || !!e.desiste_p).length > 1 ? "s" : ""} soussigné{data.clients1.filter(e => !!e.desiste || !!e.desiste_p).length > 1 ? "s" : ""} :</Text>
        </View>
        <View style={{marginVertical: 10}}>
          {data.clients1.filter(e => !!e.desiste || !!e.desiste_p).map((e, key) => (
            <ClientRow data={e} key={key} />
          ))}
        </View>
        <View style={{marginTop: 10}}>
          <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>Déclare Par La Présente :</Text>
        </View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>Se désister de :</Text>
        </View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}}>
            De {data.clients1.filter(e => !!e.desiste).length ? "la totalité" : `${data._addedClients1.length}/${data.clients1.length + data._addedClients1.length}`} de {data.clients1.filter(e => !!e.desiste || !!e.desiste_p).length > 1 ? "leur" : "ses"} droits {data.vente1?.associationPart ? "d'une part sur la réservation du Lot" : data.vente1?.TYPE?.toLowerCase().includes("app") ? "de l'Appartement" : data.vente1?.TYPE?.toLowerCase().includes("mag") ? "du Magasin" : "du Lot"} <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{`${data.vente1?.DESIGNATION || "-"}`}</Text>, Situé à {data.vente1?.societe?.constante?.valeur6 || "???"}, projet {data.vente1?.societe?.constante?.valeur2 || "???"}
          </Text>
        </View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>Au profit de :</Text>
        </View>
        <View style={{marginVertical: 10}}>
          {data._addedClients1.length ? data._addedClients1.map((e, key) => (
            <ClientRow data={{client: e}} key={key} />
          )) : <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans'}}>La société {data.vente1?.societe?.constante?.valeur || "???"} S.A.</Text>}
        </View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}}>
            Lequel désistement est fait suivant un Reçu de réservation sous seing privé en date du {data.vente1?.associationPart ? (data.vente1?.associationPart.originalDate ? moment(data.vente1.associationPart.originalDate).format('DD/MM/YYYY') : "???") : (data.vente1?.DATE_RESERV ? moment(data.vente1.DATE_RESERV).format('DD/MM/YYYY') : "???")} à {data.vente1?.societe?.constante?.valeur6 || "???"} par la Société <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{data.vente1?.societe?.constante?.valeur} S.A</Text> au profit de <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{data.clients1.map(e => `${e.client?.CIVILITE && e.client.CIVILITE !== "Ste" ? e.client?.CIVILITE : ""} ${e.client?.NOM || "???"} ${e.client?.PRENOM || ""}`).join(", ")}</Text>, dont la somme de {data.encaissements1/*?.filter(e => e.enc_supp !== 1)*//*.filter(e => e.encaissement?.STATUT && [constants.STATUT_ENC_EI, constants.STATUT_ENC_ENCAISSE, constants.STATUT_ENC_REPRESENTE].includes(e.encaissement.STATUT))*/?.reduce((e, t) => e + Number(t.PART || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs a été remis à la société{/*versée le jour de la réservation*/}.
          </Text>
        </View>
        {!!((data._addedClients1.length && !data.totalWithdraw1) && !!data.encaissements1.filter(e => !e.desiste).length) && <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}}>
            Quant à la somme de {data.encaissements1.filter(e => !e.desiste).reduce((e, t) => e + Number(t.PART || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs sera à faire valoir sur le prix d'acquisition par <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{[...data._addedClients1, ...(!data.clients1.filter(e => !!e.desiste).length && data._addedClients1.length ? data.clients1.filter(e => !!e.desiste_p).map(e => e.client) : [])].map(e => `${e.CIVILITE && e.CIVILITE !== "Ste" ? e.CIVILITE : ""} ${e.NOM || "???"} ${e.PRENOM || ""}`).join(", ")}</Text>.
          </Text>
        </View>}
        <View style={{marginVertical: 10}}>
          {data.clients1.filter(e => !!e.desiste/* || !!e.desiste_p*/).map((e, key) => 
            <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}} key={key}>
              {e.client?.CIVILITE && e.client.CIVILITE !== "Ste" ? e.client?.CIVILITE : ""} {e.client?.NOM || "???"} {e.client?.PRENOM || ""}, Se désiste de tous ses droits sur le dit lot. Et s'interdit tous recours envers la société <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{data.vente1?.societe?.constante?.valeur} S.A</Text>.
            </Text>
          )}
        </View>
        {/* <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}}>
            De manière à ce que la dite Société <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{data.vente1?.societe?.constante?.valeur} S.A</Text> en retrouvant par la présente la libre disposition de son bien, puisse en disposer au profit de qui bon lui semble, Sans qu'elle soit inquiétée à ce sujet.
          </Text>
        </View> */}
      </View>}

      {!!(data.clients1.filter(e => !!e.transfere).length && data.encaissements1.filter(e => !!e.transfere).length) && <View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>Le{data.clients1.filter(e => !!e.transfere).length > 1 ? "s" : ""} soussigné{data.clients1.filter(e => !!e.transfere).length > 1 ? "s" : ""} :</Text>
        </View>
        <View style={{marginVertical: 10}}>
          {data.clients1.filter(e => !!e.transfere).map((e, key) => (
            <ClientRow data={e} key={key} />
          ))}
        </View>
        <View style={{marginTop: 10}}>
          <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>Déclare Par La Présente :</Text>
        </View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>Transférer :</Text>
        </View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}}>
            La totalité de {data.clients1.filter(e => !!e.transfere).length > 1 ? "leur" : "ses"} droits {data.vente1?.associationPart ? "d'une part sur la réservation du Lot" : data.vente1?.TYPE?.toLowerCase().includes("app") ? "de l'Appartement" : data.vente1?.TYPE?.toLowerCase().includes("mag") ? "du Magasin" : "du Lot"} <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{`${data.vente1?.DESIGNATION || "-"}`}</Text>, Situé à {data.vente1?.societe?.constante?.valeur6 || "???"}, projet {data.vente1?.societe?.constante?.valeur2 || "???"}
          </Text>
        </View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}}>
            Lequel transfert est fait suivant un Reçu de réservation sous seing privé en date du {data.vente1?.associationPart ? (data.vente1?.associationPart.originalDate ? moment(data.vente1.associationPart.originalDate).format('DD/MM/YYYY') : "???") : (data.vente1?.DATE_RESERV ? moment(data.vente1.DATE_RESERV).format('DD/MM/YYYY') : "???")} à {data.vente1?.societe?.constante?.valeur6 || "???"} par la Société <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{data.vente1?.societe?.constante?.valeur} S.A</Text> au profit de <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{data.clients1.map(e => `${e.client?.CIVILITE && e.client.CIVILITE !== "Ste" ? e.client?.CIVILITE : ""} ${e.client?.NOM || "???"} ${e.client?.PRENOM || ""}`).join(", ")}</Text>, dont la somme de {data.encaissements1/*?.filter(e => e.enc_supp !== 1)*//*.filter(e => e.encaissement?.STATUT && [constants.STATUT_ENC_EI, constants.STATUT_ENC_ENCAISSE, constants.STATUT_ENC_REPRESENTE].includes(e.encaissement.STATUT))*/?.reduce((e, t) => e + Number(t.PART || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs a été remis à la société{/*versée le jour de la réservation*/}.
          </Text>
        </View>
       {!!data.encaissements1.filter(e => !!e.transfere).length && <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}}>
            Quant à la somme de {data.encaissements1.filter(e => !!e.transfere).reduce((e, t) => e + Number(t.PART || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs sera à faire valoir sur le prix d'acquisition par <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{data.clients1.filter(e => !!e.transfere).map(e => `${e.client?.CIVILITE && e.client.CIVILITE !== "Ste" ? e.client?.CIVILITE : ""} ${e.client?.NOM || "???"} ${e.client?.PRENOM || ""}`).join(", ")}</Text> {(data.transferToNew1 ? data.isAssociationBien1 : data.vente2?.associationPart) ? "d'une part du Lot" : (data.transferToNew1 ? data.selectedBien1 : data.vente2)?.TYPE?.toLowerCase().includes("app") ? "de l'Appartement" : (data.transferToNew1 ? data.selectedBien1 : data.vente2)?.TYPE?.toLowerCase().includes("mag") ? "du Magasin" : "du Lot"} <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{`${(data.transferToNew1 ? data.selectedBien1 : data.vente2)?.DESIGNATION || "-"}`}</Text>.
          </Text>
        </View>}
      </View>}

      {!!data.changeBien1 && <View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>Le{data.clients1.length > 1 ? "s" : ""} soussigné{data.clients1.length > 1 ? "s" : ""} :</Text>
        </View>
        <View style={{marginVertical: 10}}>
          {data.clients1.map((e, key) => (
            <ClientRow data={e} key={key} />
          ))}
        </View>
        <View style={{marginTop: 10}}>
          <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>Déclare Par La Présente :</Text>
        </View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>Transférer :</Text>
        </View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}}>
            La totalité de {data.clients1.length > 1 ? "leur" : "ses"} droits {data.vente1?.associationPart ? "d'une part sur la réservation du Lot" : data.vente1?.TYPE?.toLowerCase().includes("app") ? "de l'Appartement" : data.vente1?.TYPE?.toLowerCase().includes("mag") ? "du Magasin" : "du Lot"} <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{`${data.vente1?.DESIGNATION || "-"}`}</Text>, Situé à {data.vente1?.societe?.constante?.valeur6 || "???"}, projet {data.vente1?.societe?.constante?.valeur2 || "???"}
          </Text>
        </View>
        <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}}>
            Lequel transfert est fait suivant un Reçu de réservation sous seing privé en date du {data.vente1?.associationPart ? (data.vente1?.associationPart.originalDate ? moment(data.vente1.associationPart.originalDate).format('DD/MM/YYYY') : "???") : (data.vente1?.DATE_RESERV ? moment(data.vente1.DATE_RESERV).format('DD/MM/YYYY') : "???")} à {data.vente1?.societe?.constante?.valeur6 || "???"} par la Société <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{data.vente1?.societe?.constante?.valeur} S.A</Text> au profit de <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{data.clients1.map(e => `${e.client?.CIVILITE && e.client.CIVILITE !== "Ste" ? e.client?.CIVILITE : ""} ${e.client?.NOM || "???"} ${e.client?.PRENOM || ""}`).join(", ")}</Text>, dont la somme de {data.encaissements1/*?.filter(e => e.enc_supp !== 1)*//*.filter(e => e.encaissement?.STATUT && [constants.STATUT_ENC_EI, constants.STATUT_ENC_ENCAISSE, constants.STATUT_ENC_REPRESENTE].includes(e.encaissement.STATUT))*/?.reduce((e, t) => e + Number(t.PART || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs a été remis à la société{/*versée le jour de la réservation*/}.
          </Text>
        </View>
        {!!data.encaissements1.length && <View style={{marginVertical: 10}}>
          <Text style={{fontSize: 10, fontWeight: 300, fontFamily: 'Open Sans'}}>
            Quant à la somme de {data.encaissements1.reduce((e, t) => e + Number(t.PART || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs sera à faire valoir sur le prix d'acquisition par <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{data.clients1.map(e => `${e.client?.CIVILITE && e.client.CIVILITE !== "Ste" ? e.client?.CIVILITE : ""} ${e.client?.NOM || "???"} ${e.client?.PRENOM || ""}`).join(", ")}</Text> {data.isAssociationBien1 ? "d'une part du Lot" : data.selectedBien1?.TYPE?.toLowerCase().includes("app") ? "de l'Appartement" : data.selectedBien1?.TYPE?.toLowerCase().includes("mag") ? "du Magasin" : "du Lot"} <Text style={{fontWeight: 600, fontFamily: 'Open Sans'}}>{`${data.selectedBien1?.DESIGNATION || "-"}`}</Text>.
          </Text>
        </View>}
      </View>}

      {/* <View style={styles.bvView}> */}
      <View style={{flexDirection: "row", justifyContent: "flex-end", fontSize: 11, fontWeight: 600, fontFamily: 'Open Sans', marginTop: 20}}>
        <Text style={{fontWeight: 600, fontFamily: 'Open Sans', textDecoration: "underline"}}>{data.vente1?.societe?.constante?.valeur6 || "???"} le {moment().format('DD/MM/YYYY')}</Text>
      </View>
      {/* </View> */}

      <View style={styles.pageCountContainer} fixed>
        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => totalPages > 1 && `${pageNumber} / ${totalPages}`} fixed />
      </View>
    </MyPage>
  </MyDocument>
  )
};

export default CommissionDocument;
